// 起動モード判定とルートパラメータ取得を URL hash から行うユーティリティ。
// HashRouter のため、現在のモード(PPM/OLC)や kijshopCd は hash から導出する。
// アプリ全体で同じ判定ロジックが重複していたため1か所に集約する。

// OLC モード（URL hash に /ods/ を含む）か否か
export const isOlcMode = (): boolean => window.location.hash.includes('/ods/');

// URL hash 先頭セグメントの kijshopCd を取得（例: #/123456/ods/... → '123456'）
// 取得できない場合は空文字を返す
export const getKijshopCdFromHash = (): string =>
  window.location.hash.replace(/^#\/?/, '').split(/[/?]/)[0] ?? '';
